import React, { FC, HTMLAttributes, useEffect, useState } from "react";
import useSmoothAnchor from "lib/hooks/useSmoothAnchor";
import styled from "styled-components";
import UpFade from "components/official/UpFade";

export type Props = Record<string, never>;
const BackToTop: FC<HTMLAttributes<HTMLDivElement> & Props> = ({ ...props }) => {
  const [shown, setShown] = useState<boolean>(false);
  useEffect(() => {
    let lastScrollTop = 0;
    const onScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setShown(lastScrollTop > scrollTop && scrollTop > 70);
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    };
    document.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, []);
  useSmoothAnchor("page_top");
  return (
    <Root {...props}>
      <UpFade in={shown}>
        <Button href="#page_top">
          <Icon focusable="false" viewBox="0 0 24 24" aria-hidden="true" style={{ color: "white" }}>
            <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"></path>
          </Icon>
        </Button>
      </UpFade>
    </Root>
  );
};
export default BackToTop;

const Root = styled.div`
  position: fixed;
  z-index: 2;
  bottom: 20px;
  right: 20px;
  @media screen and (min-width: 961px) {
    //display: none;
  }
`;
const Icon = styled.svg`
  fill: currentColor;
  width: 1em;
  height: 1em;
  display: inline-block;
  font-size: 1.5rem;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  flex-shrink: 0;
  user-select: none;
`;
const Button = styled.a`
  display: inline-block;
  border: 1px solid #fff;
  background-color: black;
  border-radius: 20px;
  padding: 3px 4px;
`;
